/** Zoho is connected when OAuth completed and a refresh token is stored. */
export const isZohoAtsConfigured = (profile) => (
  Boolean(String(profile?.zoho_refresh_token ?? '').trim())
);
